import { ToastrModule } from 'ngx-toastr';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AngularFireModule } from '@angular/fire';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFirestoreModule } from '@angular/fire/firestore';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { SigninPageComponent } from './account/signin-page/signin-page.component';
import { SignupPageComponent } from './account/signup-page/signup-page.component';
import { PasswordResetPageComponent } from './account/password-reset-page/password-reset-page.component';
import { environment } from '../environments/environment';
import { AgreementComponent } from './pages/agreement/agreement.component';
import { TermsComponent } from './pages/terms/terms.component';
import { AboutComponent } from './pages/about/about.component';
import { ReleaseGuidelinesComponent } from './pages/release-guidelines/release-guidelines.component';
import { PasswordFormPageComponent } from './account/password-form-page/password-form-page.component';

@NgModule({
  declarations: [
    AppComponent,
    SigninPageComponent,
    SignupPageComponent,
    PasswordResetPageComponent,
    AgreementComponent,
    TermsComponent,
    AboutComponent,
    ReleaseGuidelinesComponent,
    PasswordFormPageComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule.enablePersistence({experimentalTabSynchronization:true}),
    AngularFireStorageModule,
    AngularFireAuthModule,
    SharedModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {}
